import React from 'react';
import GeneralSteps from '../components/GeneralSteps';

const PrivateReportView = ({ sku, userId, onFormSubmit }) => {
    return (
        <GeneralSteps
            sku={sku}
            userInfo={userId}
            onSubmit={onFormSubmit}
        />
    );
};

export default PrivateReportView;